<app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
<div class="card">

  <div class="card-body">
    <app-progress-bar [isLoading]="isLoadingRiskControl"></app-progress-bar>
    <div class="card-header px-0 d-flex w-100 align-items-end justify-content-between text-header">
      <ul class="nav template3_nav nav-tabs border-0">
        <li>
          <a class="nav-link active">Risk Summary</a>
        </li>
      </ul>
      <div class="d-flex align-items-center">
        <!-- <button
        type="button"
        class="btn btn-primary btn-sm btn-radius"
        (click)="openCreateModal()"
        
      >
         
          Add New Item
        </button> -->
        <span class="text-blue pl-3 text-capitalize" (click)="openCreateModal()">
          <span class="fa fa-plus-square-o"></span> Add New Item
        </span>
        <span class="text-capitalize pl-3" dropdown #dropdownfilters="bs-dropdown" (click)="resetFilters()"
          [autoClose]="false">
          <span dropdownToggle class="dropdown-toggle custom_badge cursor-pointer text-blue">Filters<span class="caret"
              #dropInput></span>
          </span>
        </span>
        <span class="pl-3" dropdown #dropdown="bs-dropdown" [insideClick]="true" [autoClose]="false">
          <span dropdownToggle class="cursor-pointer text-blue">
            <span class="fa fa-cog setting-icon" style="font-size: 1.4rem;" #dropInputsettings></span>
          </span>
          <div class="col-lg-3">
            <div id="dropdown-triggers-manual" *dropdownMenu
              class="dropdown-menu scheculer-settings-dropdown self-assesment-filter-dropdown p-3" role="menu"
              aria-labelledby="button-triggers-manual" style="width: 225px;">
              <div class="dropdown-filter-part pt-2">
                <div class="py-1" *ngFor="let item of riskControlActiveModel">
                  <input type="checkbox"
                    (change)="showHideColumn(item.itemTitle, item.itemWidth, item.isActive, 'Change')"
                    [(ngModel)]="item.isActive" [attr.checked]="item.isActive ? 'checked' : null" />
                  <span class="ml-2 text-capitalize">{{ item.itemTitle }}</span>
                </div>
                <button class="fa fa-times cross-button filter-close-button" type="button"
                  (click)="dropInputsettings.click()"></button>
              </div>
            </div>
          </div>
        </span>
      </div>
    </div>
    <div [class]="classTableHead" [style.max-height.px]="myInnerHeight" (scroll)="onScroll($event)">
      <!-- prime-ng -->
      <!-- prime-ng -->
      <table class="table scheduler_table rules-connection-table table-hover mb-0">
        <thead>
          <tr>
            <th style="width: 65px"></th>
            <th style="width: 120px">

              ID
            </th>
            <th style="width: 180px" *ngIf="riskControlViewModal.effectiveDate">

              Effective Date
            </th>
            <th style="width: 150px" *ngIf="riskControlViewModal.riskRef">
              Risk Ref
            </th>
            <th style="width: 150px" *ngIf="riskControlViewModal.riskArea">
              Risk Area
            </th>
            <th style="width: 150px" *ngIf="riskControlViewModal.riskCategory">
              Risk Category
            </th>
            <th style="width: 300px" *ngIf="riskControlViewModal.riskTitledate">
              Risk Title
              
            </th>
            <th style="width: 300px" *ngIf="riskControlViewModal.complianceTopicdate">
              Compliance Topic
              
            </th>
            <th style="width: 300px" *ngIf="riskControlViewModal.entitiesImpactedto">
              Entities Impacted
              to
            </th>
            <th style="width: 150px" *ngIf="riskControlViewModal.owner">
              Owner
            </th>
            <th style="width: 150px" *ngIf="riskControlViewModal.inherentRating">
              Inherent Rating
              
            </th>
            <th style="width: 150px" *ngIf="riskControlViewModal.residualRisk">
             
              Residual Risk
            </th>
            <th style="width: 200px">
              Actions
            </th>
            <!-- new -->
            <!-- <th style="width: 100px" *ngFor="let obj of extraColumn">
                {{ obj.colName }}
              </th> -->
          </tr>
        </thead>
        <tbody *ngIf="
              riskControl &&
              riskControl.length === 0
            ">
          <tr>
            <td colspan="6">No Data</td>
          </tr>
        </tbody>
        <tbody #tableBody>
          <ng-template ngFor let-item let-i="index" [ngForOf]="riskControl">
            <tr>
              <td style="width: 65px">
                <input type="checkbox" />
              </td>
              <td style="width: 120px">{{ item.id }}</td>
              <td style="width: 180px" *ngIf="riskControlViewModal.effectiveDate">
                <span class="fixed_height">{{ item.effectiveDate | date : "dd-MMM-yyyy"}}</span>
              </td>
              <td style="width: 150px" *ngIf="riskControlViewModal.riskRef">
                {{item.riskRef}}
              </td>
              <td style="width: 150px" *ngIf="riskControlViewModal.riskArea">
                {{item.riskArea}}
              </td>
              <td style="width: 150px " *ngIf="riskControlViewModal.riskCategory">
                {{item.riskCategory}}
              </td>
              <td style="width: 300px" *ngIf="riskControlViewModal.riskTitledate">
                {{ item.riskTitle}}
              </td>
              <td style="width: 300px" *ngIf="riskControlViewModal.complianceTopicdate">
                {{ item.complianceTopic }}
              </td>
              <td style="width: 300px" *ngIf="riskControlViewModal.entitiesImpactedto">{{ item.entitiesImpacted }}</td>
              <td style="width: 150px" *ngIf="riskControlViewModal.owner">
                {{ item.riskOwner }}
              </td>
              <td style="width: 150px" *ngIf="riskControlViewModal.inherentRating">
                {{ item.inherentRiskRating }}
              </td>
              <td style="width: 150px" *ngIf="riskControlViewModal.residualRisk">
                {{ item.residualRiskRating }}
              </td>
              <!-- new -->
              <td style="width: 150px">
                <span><a (click)="openEditModal(item)">Edit</a></span> | <span><a (click)="openDeleteDialog(item.id)" class="text-danger">Delete</a></span>
                 <!-- <button type="button" class="btn btn-primary btn-sm btn-radius" (click)="openEditModal(item)"
                  [disabled]="isButtonDisabled">

                  Edit
                </button> |
                <button type="button" class="btn btn-primary btn-sm btn-radius" (click)=" openDeleteDialog(item.id)"
                  [disabled]="isButtonDisabled">

                  Delete
                </button> -->
              </td>
            </tr>
            <tr *ngIf="item.riskDescription">
              <td class="desc_tableData" colspan="13">{{item.riskDescription}}</td>
            </tr>
          </ng-template>
        </tbody>
      </table>
      <!-- <mat-paginator [length]="totalCount"
               [pageIndex]="pageIndex"
               [pageSize]="pageSize"
               [pageSizeOptions]="[10, 20, 30]"
               aria-label="Select page"
               (page)="onPagechange($event)"
               [showFirstLastButtons]="showFirstLastButtons"
               class="pannel_container_paginatorFixed left-50">
        </mat-paginator> -->
    </div>
  </div>
</div>

<p-sidebar class="filterSidebar" [(visible)]="sidebarVisible" position="right">
  <app-filter-risk-control *ngIf="sidebarVisible" [riskrefList]="riskrefList" [riskAreaList]="riskAreaList"
    [riskCategoryList]="riskCategoryList" [riskTitleList]="riskTitleList" [complianceTopicList]="complianceTopicList"
    [entitiesImpactedList]="entitiesImpactedList" [riskOwnerList]="riskOwnerList"
    [riskDescriptionList]="riskDescriptionList" [applicableRulesList]="applicableRulesList"
    [riskfilterRef]="riskfilterRef" [riskfilterArea]="riskfilterArea" [riskfilterCategory]="riskfilterCategory"
    [riskfilterTitle]="riskfilterTitle" [compliancefilterTopic]="compliancefilterTopic"
    [inherentRiskRatingList]="inherentRiskRatingList" [residualRiskRatingList]="residualRiskRatingList"
    [inherentfilterRiskRatingList]="inherentfilterRiskRatingList" [residualfilterRiskRatingList]="residualfilterRiskRatingList"
    [entitiesfilterImpacted]="entitiesfilterImpacted" [riskfilterOwner]="riskfilterOwner"
    [riskfilterDescription]="riskfilterDescription" [applicablefilterRules]="applicablefilterRules"
    (filterRiskItem)="closeFilterBar($event)"></app-filter-risk-control>
</p-sidebar>